const freeQuestions = 50;

export const fontSizes = {
  english: "1rem",
  malayalam: "1rem",
  hindi: "1rem",
  bengali: "1rem",
  kannada: "1rem",
  marathi: "1rem",
  tamil: "1rem",
  telugu: "1rem",
  urdu: "1.2rem",
  gujurati: "1rem",
  punjabi: "1rem",
};

export const translations = {
  english: {
    language: "English",
    welcome: "Welcome",
    helperText: "Click the blue button",
    isRecording: "You have 30 seconds to ask a question in english",
    recordingFinished: "Time is up. Wait a few seconds...",
    cancelButton: "Cancel",
    submitButton: "Submit",
    selectLanguage: "Select language",
    selectVoice: "Voice",
    explainerModalTitle: "Greetings! 🙏🏾",
    explainerModalDescription: `You are about to interact with ChatGPT (artificial intelligence) using your voice. When prompted, ask any questions you want, except for real-time updates such as the weather, latest news, etc. You'll hear a response in 10 seconds. Sample questions you can ask:`,
    explainerModalExample1: `"Tell me about the history of the Kathakali dance"`,
    explainerModalExample2: `"Write a poem about the beauty of the Kerala backwaters"`,
    explainerModalExample3: `"Tell me a recipe for kerala style fish curry"`,
    explainerModalSignOff: `Enjoy!`,
    explainerModalUnderstand: "Okay!",
    aboutPageTitle: "About",
    aboutPageDescription:
      "Greetings and welcome to Malayalam.ai. Here, you can engage with ChatGPT using voice commands in both Malayalam and English. To begin, simply select your preferred language and pose your question. Artificial intelligence, particularly the leading generative AI tool, ChatGPT, represents a transformative advancement in technology. However, I noticed that it wasn't readily accessible to native Malayalam speakers – until now. I encourage you to explore and utilize this tool extensively. Your feedback is invaluable. Should you have any questions or suggestions for improvement, please do not hesitate to reach out to me on Instagram at @mallutrump. Thank you for your support!",
    freeQuestions: "Free Questions",
    readyButton: "Audio Ready!",
  },
  malayalam: {
    language: "മലയാളം",
    welcome: "സ്വാഗതം",
    helperText: "നീല ബട്ടണിൽ ക്ലിക്ക് ചെയ്യുക",
    isRecording:
      "നിങ്ങള്ക്ക് മലയാളത്തിൽ ഒരു ചോദ്യം ചോദിക്കാൻ 30 സെക്കന്റ് ഉണ്ട്",
    recordingFinished: "സമയം അവസാനിച്ചു. അൽപം സെക്കൻഡ് കാത്തിരിക്കുക...",
    cancelButton: "Cancel",
    submitButton: "Submit",
    selectLanguage: "Select language",
    selectVoice: "Voice",
    explainerModalTitle: "സ്വാഗതം! 🙏🏾",
    explainerModalDescription: `ഇവിടെ താങ്കൾക്ക് ChatGPT (artificial intelligence) എന്ന കമ്പ്യൂട്ടർ പ്രോഗ്രാമിനോട് സംസാരിക്കാനാവുന്നതാണ്. സന്ദേശത്തിലൂടെ  താങ്കൾക്ക് ഇഷ്ടമുള്ള ചോദ്യങ്ങളെല്ലാം ചോദിക്കാനാകും. പക്ഷേ ഇപ്പോഴത്തെ കാലാവസ്ഥ, പുതിയ വാർത്തകൾ തുടങ്ങിയ സമയാസന്ന വിവരങ്ങൾ ഇതിലൂടെ അറിയാൻ കഴിയില്ല. 10 സെക്കന്റുകളിൽ മറുപടി കേൾക്കാനാകും. ചോദിക്കാവുന്ന ചില ചോദ്യങ്ങളുടെ ഉദാഹരണങ്ങൾ ചുവടെ ചേർക്കുന്നു:`,
    explainerModalExample1: `"ബൈബിളില്‍ പൗലോസ് എത്ര പുസ്തകങ്ങൾ എഴുതി?"`,
    explainerModalExample2: `"കേരള ബാക്ക്വാറ്ററുകളുടെ സൗന്ദര്യത്തെ കുറിച്ചൊരു കവിത എഴുതുക"`,
    explainerModalExample3: `"അവിയല്‍ പോലെയുള്ള ഒരു പാരമ്പര്യമായ കേരള ഭക്ഷണത്തിന്റെ പാചകക്രമം സൃഷ്ടിക്കുക"`,
    explainerModalSignOff: `ആസ്വദിക്കുക!`,
    explainerModalUnderstand: "Okay",
    aboutPageTitle: "About",
    aboutPageDescription:
      "മലയാളം.ഐയിലേക്ക് ആശംസകളും സ്വാഗതവും. ഇവിടെ, മലയാളത്തിലും ഇംഗ്ലീഷിലുമുള്ള വോയ്‌സ് കമാൻഡുകൾ ഉപയോഗിച്ച് നിങ്ങൾക്ക് ChatGPT-യുമായി ഇടപഴകാനാകും. ആരംഭിക്കുന്നതിന്, നിങ്ങൾ തിരഞ്ഞെടുത്ത ഭാഷ തിരഞ്ഞെടുത്ത് നിങ്ങളുടെ ചോദ്യം ചോദിക്കുക. ആർട്ടിഫിഷ്യൽ ഇന്റലിജൻസ്, പ്രത്യേകിച്ച് മുൻനിര ജനറേറ്റീവ് എഐ ടൂൾ, ചാറ്റ്ജിപിടി, സാങ്കേതികവിദ്യയിലെ പരിവർത്തന പുരോഗതിയെ പ്രതിനിധീകരിക്കുന്നു. എന്നിരുന്നാലും, മാതൃഭാഷയായ മലയാളം സംസാരിക്കുന്നവർക്ക് ഇത് എളുപ്പത്തിൽ ആക്സസ് ചെയ്യാൻ കഴിയില്ലെന്ന് ഞാൻ ശ്രദ്ധിച്ചു - ഇതുവരെ. ഈ ഉപകരണം വിപുലമായി പര്യവേക്ഷണം ചെയ്യാനും ഉപയോഗിക്കാനും ഞാൻ നിങ്ങളെ പ്രോത്സാഹിപ്പിക്കുന്നു. നിങ്ങളുടെ പ്രതികരണം വിലമതിക്കാനാവാത്തതാണ്. മെച്ചപ്പെടുത്തുന്നതിന് നിങ്ങൾക്ക് എന്തെങ്കിലും ചോദ്യങ്ങളോ നിർദ്ദേശങ്ങളോ ഉണ്ടെങ്കിൽ, @mallutrump-ൽ Instagram-ൽ എന്നെ ബന്ധപ്പെടാൻ മടിക്കരുത്. നിങ്ങളുടെ പിന്തുണയ്ക്ക് നന്ദി!",
    freeQuestions: "Free ചോദ്യങ്ങൾ",
    readyButton: "ഉത്തരം തരൂ",
  },
  hindi: {
    language: "हिंदी",
  },
  bengali: {
    language: "বাংলা",
  },
  kannada: {
    language: "ಕನ್ನಡ",
  },
  marathi: {
    language: "मराठी",
  },
  tamil: {
    language: "தமிழ்",
  },
  telugu: {
    language: "తెలుగు",
  },
  urdu: {
    language: "اردو",
  },
  gujurati: {
    language: "ગુજરાતી",
  },
  punjabi: {
    language: "ਪੰਜਾਬੀ",
  },
};
